// extracted by mini-css-extract-plugin
export default {"Input":"NameBox_Input__llyPU"};